var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitterFooter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "noun-twitter-6755467",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.318,
    height: 24.318,
    viewBox: "0 0 24.318 24.318",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_95",
    "data-name": "Path 95",
    d: "M18.637,27.034a.392.392,0,1,1,0,.784H6.2a2.71,2.71,0,0,1-2.7-2.7V6.2A2.7,2.7,0,0,1,4.3,4.295l.023-.021A2.7,2.7,0,0,1,6.206,3.5h1.1a.392.392,0,1,1,0,.784h-1.1A1.923,1.923,0,0,0,4.288,6.2V25.116a1.922,1.922,0,0,0,1.917,1.917H18.638ZM15.985,13.309l4.959-6.03a.392.392,0,0,1,.323-.17h2.209a.4.4,0,0,1,.248.091.391.391,0,0,1,.053.551l-6.305,7.667,5.77,8.174a.392.392,0,0,1-.32.617h-3a.393.393,0,0,1-.334-.186L15.341,18.01l-4.959,6.03a.392.392,0,0,1-.323.17H7.85a.4.4,0,0,1-.248-.091.391.391,0,0,1-.053-.551L13.854,15.9,8.084,7.727A.392.392,0,0,1,8.4,7.11h3a.393.393,0,0,1,.334.186l4.245,6.014Zm-3.3-9.024a.392.392,0,1,1,0-.784H25.119a2.7,2.7,0,0,1,1.909.793l.021.023A2.7,2.7,0,0,1,27.822,6.2V25.115a2.712,2.712,0,0,1-2.7,2.7h-1.1a.392.392,0,1,1,0-.784h1.1a1.922,1.922,0,0,0,1.918-1.917V6.2A1.923,1.923,0,0,0,25.12,4.285H12.689Z",
    transform: "translate(-3.504 -3.5)",
    fill: "#f8f4f1",
    stroke: "#5d0d19",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterFooter);
export default __webpack_public_path__ + "static/media/twitter_footer.759726fb7dc76580c3d19d3993322f60.svg";
export { ForwardRef as ReactComponent };